import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { FOUNDER_IMG } from "../../data/content";
import { CtaButton, Eyebrow, Reveal } from "./Primitives";

export const Founder = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [40, -40]);

  return (
    <section ref={ref} id="founder" data-testid="founder-intro-section" className="relative mx-auto max-w-7xl px-5 py-24 sm:px-8 lg:py-32">
      <div className="grid items-center gap-14 lg:grid-cols-12">
        <Reveal className="lg:col-span-5">
          <div className="relative mx-auto max-w-md">
            <div className="founder-spot relative aspect-[4/5] overflow-hidden rounded-[32px] border border-ink/10">
              <motion.img style={{ y }} src={FOUNDER_IMG} alt="Abhishek Sharma, founder of Coenzio" className="absolute inset-x-0 bottom-[-40px] mx-auto h-[105%] object-contain object-bottom" />
            </div>
            <div className="absolute -bottom-6 left-6 right-6 rounded-2xl border border-ink/10 bg-white/90 p-4 backdrop-blur-xl sm:left-auto sm:right-[-24px] sm:w-64">
              <div className="font-display text-lg font-bold text-ink">Abhishek Sharma</div>
              <div className="text-[13px] text-ink/60">Founder, Coenzio · 10 years in B2B revenue</div>
            </div>
          </div>
        </Reveal>
        <div className="lg:col-span-7 lg:pl-8">
          <Reveal>
            <Eyebrow>The founder</Eyebrow>
            <h2 className="mt-5 font-display text-4xl font-bold leading-[1.05] tracking-[-0.03em] text-ink sm:text-5xl">10 years building revenue engines. <span className="font-serif font-normal italic text-cobalt-700">Now I'm building Coenzio.</span></h2>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="mt-8 space-y-5 text-base leading-relaxed text-ink/70 sm:text-lg">
              <p>For the last decade, I've worked behind the scenes building B2B sales systems, generating pipeline, and helping companies turn outbound into revenue.</p>
              <p>I've worked across IT services, SaaS, AI, healthcare, agencies, and professional services — from generating thousands of qualified opportunities to helping businesses scale revenue.</p>
              <p>Eventually I realized something:</p>
            </div>
            <blockquote className="mt-8 border-l-2 border-cobalt-700 pl-6 font-serif text-2xl italic leading-snug text-ink sm:text-3xl">
              Most companies don't need another lead-generation vendor. They need someone willing to take responsibility for the revenue system.
            </blockquote>
            <p className="mt-6 text-base text-ink/70 sm:text-lg">That's why I started Coenzio.</p>
            <CtaButton testId="founder-cta" className="mt-10">Talk to Abhishek</CtaButton>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
